import { forwardRef } from 'react';

import type { ButtonWithIconsProps } from '@polyai/ui/components/atoms/Button';
import Button from '@polyai/ui/components/atoms/Button';
import { cn } from '@polyai/ui/utils/cn';

type FadeButtonProps = ButtonWithIconsProps & { isExpanded: boolean };

const FadeButton = forwardRef<HTMLButtonElement, FadeButtonProps>(
  ({ isExpanded, className, ...props }, ref) => (
    <Button
      ref={ref}
      className={cn(
        'w-full bg-background-primary rounded-none hover:bg-background-primary-hover',
        '[&_svg]:flex-shrink-0',
        '[&_.buttonLabel]:overflow-hidden [&_.buttonLabel]:inline-block [&_.buttonLabel]:[text-overflow:ellipsis] [&_.buttonLabel]:whitespace-nowrap',
        '[&_.buttonLabel]:transition-[width,min-width,margin,opacity] [&_.buttonLabel]:duration-200 [&_.buttonLabel]:ease-in-out',
        '[&_.buttonEndAdornment]:overflow-hidden [&_.buttonEndAdornment]:inline-flex',
        '[&_.buttonEndAdornment]:transition-[width,min-width,margin,opacity] [&_.buttonEndAdornment]:duration-200 [&_.buttonEndAdornment]:ease-in-out',
        '[&>span]:justify-start [&>span]:transition-[gap,justify-content] [&>span]:duration-200 [&>span]:ease-in-out',
        isExpanded
          ? '!pl-sm1 [&_.buttonEndAdornment]:ml-auto'
          : [
              '!px-xs2',
              '[&_.buttonLabel]:w-0 [&_.buttonLabel]:min-w-[auto] [&_.buttonLabel]:[margin:0] [&_.buttonLabel]:opacity-0',
              // BaseIcon wrapper uses display:contents so width/opacity on the
              // .buttonEndAdornment span are ignored — must target the inner svg.
              '[&_.buttonEndAdornment_svg]:!opacity-0 [&_.buttonEndAdornment_svg]:w-0',
              '[&>span]:gap-0 [&>span]:justify-center',
            ],
        className,
      )}
      {...props}
    />
  ),
);

export default FadeButton;
